<template>
  <ui-sidepage extra-large :close="recalculateTotalsAndClose" :title='spec.title'>

    <div class="mb-8">
      <ui-button-new small icon="fas fa-file-export" @click="$store.copyToGlobalSpec(spec)">Copy to Global Spec
        Library
      </ui-button-new>
    </div>

    <!-- Related items. -->
    <div class="bg-gray-50 p-6 rounded-lg border border-gray-200 mb-8 text-sm">
      <div v-if="relatedItems.length > 0">
        <p class="mb-2">
          This local spec is associated with the following items:
        </p>
        <ul class="flex flex-wrap -m-1">
          <li
              v-for="item in relatedItems"
              :key="item.key"
              class="px-3 py-0.5 rounded border bg-white font-medium m-1"
              v-text="item.custom_ref || item.ref"
          ></li>
        </ul>
      </div>
      <div v-else>
        <p class="text-gray-500 mb-2">This local spec is not associated with any item.</p>
        <ui-button-new small danger icon="fa fa-trash" @click.stop.prevent="deleteForm.submit()"
                       :loading="deleteForm.busy">Delete this local spec
        </ui-button-new>
      </div>
    </div>

    <!-- Form. -->
    <global-specs-form-classic
        :form="form"
        :estimate="estimate"
        :read-only="estimate.cannot_be_edited_by_authed_user"
        @updated="submitForm"
    ></global-specs-form-classic>
  </ui-sidepage>
</template>

<script>
import {debounce} from 'lodash'
import {estimateStore} from '@stores'

export default {
  props: ['spec', 'close'],
  data() {
    return {
      form: new Form(this.spec.getFormAttributes(), async (form) => {
        await this.spec.update(form.export())
        form.materials_cost_per_uom = this.spec.materials_cost_per_uom
        form.labour_cost_per_uom = this.spec.labour_cost_per_uom
        form.cost_per_uom = this.spec.cost_per_uom
      }),
      deleteForm: new Form({}, async () => {
        await this.$store.deleteLocalSpec(this.spec.id)
        this.close()
      }),
    }
  },
  computed: {
    $store() {
      return estimateStore
    },
    estimate() {
      return this.$store.state.estimate
    },
    relatedItems() {
      return this.$store.getItemsUsingSpec(this.spec)
    },
  },
  methods: {
    recalculateTotalsAndClose() {
      setTimeout(async () => {
        this.close()
        await this.$store.forceMaterialListRebuild()
        await this.$store.refreshAndRecalculateLocalSpecs()
        this.$store.recalculateTotals()
      }, 0)
    },
    submitForm: debounce(async function (payload = {}) {
      await this.form.submit()
      if (payload?.is_material_change) {
        this.$store.refreshAndRecalculateLocalSpecs()
      }
    }, 250),
  },
}
</script>
